/**
 * @fileoverview Servicio para gestión de acciones formativas
 * @description Maneja todas las peticiones HTTP relacionadas con acciones formativas
 */

import { defaultConfig, handleResponse, buildApiUrl, API_ENDPOINTS } from '../config/api';

/**
 * Servicio para gestión de acciones formativas
 */
export const accionFormativaService = {
  /**
   * Crea una nueva acción formativa con sus cursos asociados
   * @param data - Datos de la acción formativa y cursos
   * @returns Promise con la respuesta del servidor
   */
  async crearAccionFormativa(data: any) {
    const response = await fetch(buildApiUrl(API_ENDPOINTS.ACCION_FORMATIVA), {
      method: 'POST',
      ...defaultConfig,
      body: JSON.stringify(data),
    });
    
    return handleResponse(response);
  },

  /**
   * Obtiene una acción formativa por ID
   * @param id - ID de la acción formativa
   * @returns Promise con los datos de la acción formativa
   */
  async obtenerAccionFormativa(id: number) {
    const response = await fetch(buildApiUrl(`${API_ENDPOINTS.ACCION_FORMATIVA}/${id}`), {
      method: 'GET',
      ...defaultConfig,
    });
    return handleResponse(response);
  },

  /**
   * Actualiza una acción formativa existente
   * @param id - ID de la acción formativa
   * @param data - Datos actualizados de la acción formativa y cursos
   * @returns Promise con la respuesta del servidor
   */
  async actualizarAccionFormativa(id: number, data: any) {
    const response = await fetch(buildApiUrl(`${API_ENDPOINTS.ACCION_FORMATIVA}/update/${id}`), {
      method: 'PUT',
      ...defaultConfig,
      body: JSON.stringify(data),
    });
    
    return handleResponse(response);
  }
};
